import { BelongsToReferenceField, pageCollectionFields } from 'drapcode-constant';
import {
  fieldTraitProgressBarOptions,
  fieldTraitTextContentOptions,
} from '../../dataGroup/traitsApi';
import { getCollectionFields } from '../../pluginComponentApi';
export const AreaChartBlock = (bm, category, label, type) => {
  bm.add(type, {
    label: `<i class="webconnect-area-chart"></i><div>${label}</div>`,
    category: category,
    content: `<div data-gjs-type="area_chart">
    <img src="https://public-webconnect.s3.amazonaws.com/chart/area-chart.png" />
  </div>`,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, collections, bindCollectionOptions, snippetCollectionTraitOptions } = config;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-area-chart"></i>',
          projectId: projectId,
          name: 'Area Chart',
          traits: [
            {
              type: 'select',
              label: 'Stroke Curve',
              name: 'strokeCurve',
              value: 'smooth',
              changeProp: 1,
              options: [
                { id: 'smooth', name: 'Spline' },
                { id: 'straight', name: 'Straight' },
                { id: 'stepline', name: 'Stepline' },
              ],
            },
            {
              type: 'number',
              label: 'Height',
              name: 'chartHeight',
              changeProp: 1,
              value: 300,
              min: 100,
              step: 10,
              max: 1000,
            },
            {
              type: 'checkbox',
              label: 'Zoom',
              name: 'chartZoom',
              changeProp: 1,
            },
            {
              type: 'checkbox',
              label: 'Data Labels',
              name: 'chartDataLabel',
              changeProp: 1,
            },
            {
              type: 'text',
              label: 'Title',
              name: 'title',
              changeProp: 1,
            },
            {
              type: 'text',
              label: 'X Axis Title',
              name: 'xaxis_title',
              changeProp: 1,
            },
            {
              type: 'number',
              label: 'X Axis Label Rotation',
              name: 'xaxis_label_rotate',
              changeProp: 1,
              value: 0,
              min: -90,
              step: 1,
              max: 90,
            },
            {
              type: 'text',
              label: 'Y Axis Title',
              name: 'yaxis_title',
              changeProp: 1,
            },
            {
              type: 'number',
              label: 'Y Axis Min',
              name: 'yaxis_min',
              changeProp: 1,
              value: '',
              min: 0,
              step: 10,
              max: 1000,
            },
            {
              type: 'number',
              label: 'Y Axis Max',
              name: 'yaxis_max',
              changeProp: 1,
              value: '',
              min: 0,
              step: 10,
              max: 1000,
            },
            {
              type: 'text',
              label: 'Y Axis Range #1',
              name: 'yaxis_range1',
              changeProp: 1,
            },
            {
              type: 'text',
              label: 'Background Color Range #1',
              name: 'background_color_range1',
              changeProp: 1,
            },
            {
              type: 'text',
              label: 'Y Axis Range #2',
              name: 'yaxis_range2',
              changeProp: 1,
            },
            {
              type: 'text',
              label: 'Background Color Range #2',
              name: 'background_color_range2',
              changeProp: 1,
            },
            {
              type: 'text',
              label: 'Data Series Label',
              name: 'dataSeriesLabel',
              changeProp: 1,
            },
          ],
          script: function () {
            const title = '{[ title ]}';
            const chartDataLabel = '{[ chartDataLabel ]}';
            const chartZoom = '{[ chartZoom ]}';
            const chartHeight = '{[ chartHeight ]}';
            const strokeCurve = '{[ strokeCurve ]}';
            const yAxisTitle = '{[ yaxis_title ]}';
            const xAxisTitle = '{[ xaxis_title ]}';
            const dataSeriesLabel = '{[ dataSeriesLabel ]}';
            let collectionId = '{[ collectionName ]}';
            const finderId = '{[ finderUuid ]}';

            const chartData = {
              title,
              chartDataLabel,
              chartZoom,
              chartHeight,
              strokeCurve,
              xAxisTitle,
              yAxisTitle,
              dataSeriesLabel,
            };
            if (typeof renderAreaChart !== 'undefined') {
              renderAreaChart(this, chartData, collectionId, finderId);
            }
          },
        },
        async init() {
          const collectionName = this.get('collectionName');
          let options = collections.map((item) => {
            return { value: item.collectionName, name: item.collectionTitle };
          });
          this.addTrait([
            {
              type: 'select',
              label: 'Collection',
              name: 'collectionName',
              changeProp: 1,
              options: options,
            },
            {
              type: 'select',
              label: 'Filter',
              name: 'finderUuid',
              changeProp: 1,
            },
          ]);
          if (collectionName) {
            const selectedCollection = collections.find(
              (collection) => collection.collectionName === collectionName,
            );
            const finderOptions = selectedCollection
              ? selectedCollection.finders.map((finder) => {
                  return { value: finder.uuid, name: finder.name };
                })
              : [];
            this.getTrait('finderUuid').set({ options: finderOptions });
            const numberFieldTraitsOptions = fieldTraitProgressBarOptions(selectedCollection);
            const fieldTraitsOptions = await fieldTraitTextContentOptions(selectedCollection);
            this.addTrait({
              name: 'data-series',
              label: 'Y Axis Data',
              options: numberFieldTraitsOptions,
              title: `series-data`,
              type: 'data-series-trait',
            });

            this.addTrait({
              name: 'data-xaxis',
              label: 'X Axis Data',
              options: fieldTraitsOptions,
              title: `xaxis-data`,
              type: 'data-series-trait',
            });
            const finder = this.get('finderUuid');
            const finders = selectedCollection ? selectedCollection.finders : [];
            const selectedFinder = finders.find((currentFinder) => currentFinder.uuid === finder);
            let externalQueryParamKeys = [];
            if (selectedFinder && selectedFinder.noOfExternalParams > 0) {
              let pageCollection = [];
              if (bindCollectionOptions.collection) {
                pageCollection = bindCollectionOptions.collection;
              } else if (snippetCollectionTraitOptions.collection) {
                pageCollection = snippetCollectionTraitOptions.collection;
              }
              let pageCollectionOptions = pageCollection ? pageCollection.options : [];
              pageCollectionOptions = pageCollectionOptions.filter((opt) =>
                [...pageCollectionFields, ...BelongsToReferenceField].includes(opt.type),
              );
              if (selectedFinder.conditions) {
                selectedFinder.conditions.forEach((condition) => {
                  if (condition.requiredExternal) {
                    const {
                      query: { value },
                    } = condition;
                    if (value.includes('---')) {
                      const values = value.split('---');
                      externalQueryParamKeys.push(values[0]);
                      externalQueryParamKeys.push(values[1]);
                    } else {
                      externalQueryParamKeys.push(value);
                    }
                  }
                });
              }

              if (externalQueryParamKeys.length > 0) {
                externalQueryParamKeys.forEach((extParam) => {
                  this.addTrait({
                    name: extParam,
                    label: extParam,
                    options: pageCollectionOptions,
                    title: extParam,
                    type: 'finder-query-param-trait',
                  });
                });
              }
              const currentAttributes = this.getAttributes() || {};
              this.set({
                attributes: {
                  ...currentAttributes,
                  externalQueryParamKeys: externalQueryParamKeys,
                },
              });
            }
          }
          this.on('change:collectionName', this.handleCollectionChange);
          this.on('change:finderUuid', this.handleFinderChange);
          this.on(
            'change:yaxis_title change:xaxis_title change:title change:chartDataLabel change:chartZoom change:chartHeight change:strokeCurve change:dataSeriesLabel change:yaxis_max change:yaxis_min change:xaxis_label_rotate change:yaxis_range1 change:background_color_range1 change:yaxis_range2 change:background_color_range2',
            this.updateAttributes,
          );
        },
        async handleCollectionChange() {
          const collectionName = this.get('collectionName');
          const collection = await getCollectionFields(collectionName, collections);
          if (collection) {
            const finderOptions = [];
            collection.finders.forEach((finder) => {
              finderOptions.push({ value: finder.uuid, name: finder.name });
            });
            this.getTrait('finderUuid').set({ options: finderOptions });
            this.removeTrait('data-series');
            this.removeTrait('data-xaxis');
            const numberFieldTraitsOptions = fieldTraitProgressBarOptions(collection);
            const fieldTraitsOptions = await fieldTraitTextContentOptions(collection);
            this.addTrait({
              name: 'data-series',
              label: 'Y Axis Data',
              options: numberFieldTraitsOptions,
              title: `series-data`,
              type: 'data-series-trait',
            });
            this.addTrait({
              name: 'data-xaxis',
              label: 'X Axis Data',
              options: fieldTraitsOptions,
              title: `xaxis-data`,
              type: 'data-series-trait',
            });
            const allTraits = this.get('traits');
            const removeTraits = [];
            allTraits.map((trait) => {
              if (trait.props().type === 'finder-query-param-trait') {
                removeTraits.push(trait.props().name);
              }
            });
            removeTraits.map((trait) => this.removeTrait(trait));
          }
          this.updateAttributes();
        },
        async handleFinderChange() {
          const collectionName = this.get('collectionName');
          const collection = await getCollectionFields(collectionName, collections);
          const finder = this.get('finderUuid');
          const finders = collection ? collection.finders : [];
          const selectedFinder = finders.find((currentFinder) => currentFinder.uuid === finder);
          const allTraits = this.get('traits');
          const removeTraits = [];
          allTraits.map((trait) => {
            if (trait.props().type === 'finder-query-param-trait') {
              removeTraits.push(trait.props().name);
            }
          });
          removeTraits.map((trait) => this.removeTrait(trait));
          const externalQueryParamKeys = [];
          if (selectedFinder && selectedFinder.noOfExternalParams > 0) {
            let pageCollection = [];
            if (bindCollectionOptions.collection) {
              pageCollection = bindCollectionOptions.collection;
            } else if (snippetCollectionTraitOptions.collection) {
              pageCollection = snippetCollectionTraitOptions.collection;
            }
            let pageCollectionOptions = pageCollection ? pageCollection.options : [];
            pageCollectionOptions = pageCollectionOptions.filter((opt) =>
              pageCollectionFields.includes(opt.type),
            );
            if (selectedFinder.conditions) {
              selectedFinder.conditions.forEach((condition) => {
                if (condition.requiredExternal) {
                  const {
                    query: { value },
                  } = condition;
                  if (value.includes('---')) {
                    const values = value.split('---');
                    externalQueryParamKeys.push(values[0]);
                    externalQueryParamKeys.push(values[1]);
                  } else {
                    externalQueryParamKeys.push(value);
                  }
                }
              });
            }

            if (externalQueryParamKeys.length > 0) {
              externalQueryParamKeys.forEach((extParam) => {
                this.addTrait({
                  name: extParam,
                  label: extParam,
                  options: pageCollectionOptions,
                  title: extParam,
                  type: 'finder-query-param-trait',
                });
              });
            }
          }
          const currentAttributes = this.getAttributes() || {};
          this.set({
            attributes: {
              ...currentAttributes,
              externalQueryParamKeys: externalQueryParamKeys,
            },
          });
          this.updateAttributes();
        },
        updateAttributes() {
          const currentAttributes = this.getAttributes();
          const updatedAttributes = {
            ...currentAttributes,
            'data-chart-type': 'Area',
            'data-chart-title': this.get('title'),
            'data-chart-data-label': this.get('chartDataLabel'),
            'data-chart-zoom': this.get('chartZoom'),
            'data-chart-height': this.get('chartHeight'),
            'data-stroke-curve': this.get('strokeCurve'),
            'data-collection-id': this.get('collectionName'),
            'data-finder-id': this.get('finderUuid'),
            'data-series': this.get('data-series'),
            'data-xaxis': this.get('data-xaxis'),
            'data-y-axis-title': this.get('yaxis_title'),
            'data-x-axis-title': this.get('xaxis_title'),
            'data-series-label': this.get('dataSeriesLabel'),
            'data-y-axis-min': this.get('yaxis_min'),
            'data-y-axis-max': this.get('yaxis_max'),
            'data-x-axis-label-rotate': this.get('xaxis_label_rotate'),
            'data-y-axis-range1': this.get('yaxis_range1'),
            'data-background-color-range1': this.get('background_color_range1'),
            'data-y-axis-range2': this.get('yaxis_range2'),
            'data-background-color-range2': this.get('background_color_range2'),
          };
          if (JSON.stringify(currentAttributes) !== JSON.stringify(updatedAttributes)) {
            this.setAttributes(updatedAttributes);
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        this.listenTo(model, 'change:title', this.updateScript);
        this.listenTo(model, 'change:chartDataLabel', this.updateScript);
        this.listenTo(model, 'change:chartZoom', this.updateScript);
        this.listenTo(model, 'change:chartHeight', this.updateScript);
        this.listenTo(model, 'change:strokeCurve', this.updateScript);
      },
    }),
  });
};
